
import { Component, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import OrbatChart from "../components/OrbatChart.vue";
import SlidePanel from "../components/SlidePanel.vue";
import MilSymbol from "../components/MilSymbol.vue";
import { ChartOrientation, OrbChartOptions, SpecificOptions, Unit } from "orbatchart";

import OrbatTree from "@/components/OrbatTree.vue";
import { PanelMixins, SettingsPanelMixins } from "@/components/mixins";
import SettingsPanel from "@/components/SettingsPanel.vue";
import { EventBus, LEVEL_CLICK, LEVELGROUP_CLICK, UNIT_CLICK } from "@/eventbus";

@Component({
  components: {
    SettingsPanel,
    OrbatTree,
    OrbatChart,
    SlidePanel,
    MilSymbol,
  },
})
export default class MainView extends mixins(PanelMixins, SettingsPanelMixins) {
  created() {
    this.currentUnit = this.orbat[0];
  }

  get orbat(): Unit[] {
    return this.$store.state.orbat.rootUnits;
  }

  get currentUnit(): Unit {
    return this.$store.getters.currentUnit;
  }

  set currentUnit(unit: Unit) {
    this.$store.commit("setCurrentUnit", unit)
  }

  get specificOptions(): SpecificOptions {
    return this.$store.getters.specificOptions;
  }

  onSlide() {
    //console.log("Slick'n slide")
  };


  onUnitClick(unit) {
    console.log("Clicked", unit.unit.name);
    EventBus.$emit(UNIT_CLICK, unit.unit.id);
  };

  onLevelClick(levelNumber) {
    EventBus.$emit(LEVEL_CLICK, levelNumber);
  };

  onLevelGroupClick(id) {
    EventBus.$emit(LEVELGROUP_CLICK, id);
  }

  onSelectUnit(unit: Unit) {
    EventBus.$emit(UNIT_CLICK, unit);
    this.currentUnit = unit;
  }
}

